
<div class="content-container">
	<section class="data-table invoice all-lists">
		<invoices-header *ngIf="!activeInvoice && (activeTab != 'create-invoice')"
			[allInvoices]="allInvoices"
			[closedInvoices]="closedInvoices"
			[pendingInvoices]="pendingInvoices"
			[userInfo]="userInfo"
		></invoices-header>

		<div class="data-table__wrap">
			<div class="create-new-page showing">

        <invoices-tab-header
          [invoicesCount]="invoicesCount"
          [receivedPaymentsCount]="receivedPaymentsCount"
          [draftsCount]="draftsCount"
          [activeTab]="activeTab"
          (changeTab)="switchTab($event)"
          (onSearch)="searchInvoices($event)"
          (recordPayment)="recordPayment()"
          (quickPayment)="quickPayment()"
          (toggleTableMenu)="toggleTableMenu()"
          (filterByDate)="filterByDate($event)"
          (filterByAmount)="filterByAmount($event)"
          (filterByStatus)="filterByStatus($event)"
          [userInfo]="userInfo"
        ></invoices-tab-header>

        <div [hidden]="activeTab !== 'all-invoices'" >
          <teemapp-v2-table
            [name]="'invoices'"
            [tableSchema]="invoicesTable"
            [selectable]="false"
            [menuItems]="invoiceMenuItems"
            (onLoad)="onLoadInvoices($event)"
            (onSelect)="onSelectInvoices($event)"
            #invoicesTableRef
          ></teemapp-v2-table> <!-- [menuItems]="invoiceMenuItems" -->
        </div>

        <!-- <div [hidden]="activeTab !== 'received-payments'" >
          <teemapp-table
            [name]="'received-payments'"
            [tableSchema]="receivedPaymentsTable"
            [selectable]="false"
            [divClass]="'invoiceReceved'"
            (onLoad)="onLoadReceivedPayments($event)"
            #receivedPaymentsTableRef
          ></teemapp-table>
        </div> -->

        <!-- <div [hidden]="activeTab !== 'drafts'" >
          <teemapp-table
            [name]="'drafts'"
            [tableSchema]="draftsTable"
            [selectable]="true"
            [menuItems]="draftMenuItems"
            (onLoad)="onLoadDrafts($event)"
            (onSelect)="onSelectDraft($event)"
            #draftsTableRef
          ></teemapp-table>
        </div> -->

        <div *ngIf="activeTab == 'create-invoice'" >
          <create-invoice-form
            [clientUid]="selectedClientUid"
            (onCreate)="onSubmitCreateInvoice($event)"
            (changeTab)="switchTab($event)"
            (onEdit)="editInvoice($event)"
            [userInfo]="userInfo"
          ></create-invoice-form>
        </div>

        <div *ngIf="activeTab == 'view-invoice'" >
          <view-invoice
            [invoiceDetail]="activeInvoice"
            (onEdit)="editInvoice($event)"
            (doAction)="doAction($event)"
            (payIncash)="payIncash($event)"
            (onDelete)="onDeleteInvoice($event)"
            (onView)="viewInvoice($event)"
            (changeTab)="switchTab($event)"
            (recordPayment)="recordNewPayment($event)"
            (refundPayment)="refundPayment($event)"
          ></view-invoice>
        </div>

        <div *ngIf="activeTab == 'edit-invoice'" >
          <edit-invoice
            [invoiceDetail]="activeInvoice"
            (onUpdate)="onSubmitEditInvoice($event)"
            (onDelete)="onDeleteInvoice($event)"
            [userInfo]="userInfo"
            (changeTab)="switchTab($event)"
          ></edit-invoice>
        </div>

        <div *ngIf="activeTab == 'recall-invoice'" >
          <recall-invoice-form
            [invoiceDetail]="activeInvoice"
            (onCreate)="onSubmitCreateInvoice($event)"
            (changeTab)="switchTab($event)"
            (onEdit)="editInvoice($event)"
            [userInfo]="userInfo"
            (changeTab)="switchTab($event)"
          ></recall-invoice-form>
        </div>
		  </div>
		</div>
	</section>
</div>
